import React from "react";
import HeroImage from './images/pmo-hero.webp';

const PMOServices = () => {
    return (
        <div className="w-full lg:h-screen flex flex-col-reverse lg:flex-row lg:py-28 lg:px-20 md:py-12 md:px-12 py-6 px-4 gap-8 items-center lg:justify-between justify-center text-left lg:container mx-auto">
            <div className="flex flex-col gap-6 w-full lg:w-1/2 text-left">
                <h1 className="lg:text-6xl md:text-5xl text-3xl pointer-events-none text-blue10 font-normal leading-snug md:leading-snug lg:leading-snug">Your PMO, Ready to Go.</h1>
                <p className="lg:text-2xl md:text-xl text-base leading-relaxed pointer-events-none text-blue70 font-semibold"> A high-impact turn key service that sets up your tailored Project Management Office in just 4–6 weeks, without the overhead of traditional consulting.</p>
            </div>
            <img src={HeroImage} alt="PMG ReadyPMO — fractional Project Management Office setup in 4–6 weeks" fetchpriority="high" decoding="async" width="600" height="600" className="object-cover aspect-square rounded-2xl w-full lg:w-1/2" />
        </div>
    );
}

export default PMOServices;